import type { ReactNode } from "react";

export function LogoMark(props: { readonly size?: number | undefined }): ReactNode {
  const size = props.size ?? 28;
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true" className="shrink-0">
      <rect width="32" height="32" rx="8" fill="#62F0D8" />
      <path
        d="M11 23V9h6a5 5 0 010 10h-6"
        fill="none"
        stroke="#03161B"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/** Wordmark follows the FlowDesign logo: neutral first word, accent second word. */
export function Logo(props: { readonly size?: number | undefined }): ReactNode {
  return (
    <span className="inline-flex items-center gap-2.5">
      <LogoMark size={props.size ?? 26} />
      <span className="font-display text-[1.02rem] font-extrabold leading-none tracking-[-0.02em] text-foam">
        Password<span className="text-flow">Flow</span>
      </span>
    </span>
  );
}
